import React from 'react';
import withIcon from '../utilities/withIcon';

const IconX = () => {
  return (
    <g>
      <path d="m9.0605 8 4.1395-4.1394a.75.75 0 0 0 -1.06-1.0606l-4.14 4.1394-4.14-4.1394a.75.75 0 0 0 -1.06 1.0606l4.1395 4.1394-4.1395 4.1394a.75.75 0 1 0 1.06 1.0606l4.14-4.1395 4.14 4.1395a.75.75 0 0 0 1.06-1.0606z" />
    </g>
  );
};

export default withIcon(IconX);
